@for (modal of modalList$ | async; track itemTrackBy($index, modal)) {
  <app-block-factory
    [blockId]="modal.block"
    [injectData]="getModalData(modal)"
  ></app-block-factory>
}
